"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._SelfServiceAppointmentsReferences = exports._SelfServiceModuleUpgradeReferences = exports._SelfServiceMembershipUpgradeReferences = void 0;
exports._SelfServiceMembershipUpgradeReferences = {
    contractUpgrades: {
        required: false,
        uid: 'contractUpgrades',
        description: 'Replicated for each possible contract upgrade',
    },
    upgradeMembership: {
        dataTag: 'action',
        required: false,
        uid: 'upgradeMembership',
        dontRemoveFromDom: true,
        keepRefTag: true,
        description: 'Button to do the membership switch. Has to be inside data-ref="contractUpgrades" and will perform the upgrade immediately for a one-click upsell. If data-module="preview" is used on the page, it will show a preview first.',
    },
    membershipUpgradeId: {
        dataTag: 'get',
        required: false,
        uid: 'membershipUpgradeId',
        dontRemoveFromDom: true,
        description: 'Radio buttons for the membership upgrade selection. Has to be on the radio element, not the label. Name and value of the radios does not matter. Has to be inside data-ref="contractUpgrades". Should not be used with the upgradeMembership button.',
    },
    confirmUpgradeMembershipSelection: {
        dataTag: 'action',
        required: false,
        uid: 'confirmUpgradeMembershipSelection',
        dontRemoveFromDom: true,
        keepRefTag: true,
        description: 'Button confirm the selected membership. Has to be outside data-ref="contractUpgrades". Has to used with radio-buttons with name="membershipUpgradeId". If data-module="preview" is used on the page, it will show a preview first.',
    },
};
exports._SelfServiceModuleUpgradeReferences = {
    additionalModules: {
        required: false,
        keepRefTag: true,
        dontRemoveFromDom: true,
        uid: 'additionalModules',
        description: 'Needs to be inside data-ref="contracts", replicated for each possible addon of the given contract',
    },
    purchaseAdditionalModule: {
        dataTag: 'action',
        required: false,
        keepRefTag: true,
        dontRemoveFromDom: true,
        uid: 'purchaseAdditionalModule',
        description: 'Needs to be inside data-ref="additionalModules", a click on this element will trigger the purchase of the module',
    },
};
exports._SelfServiceAppointmentsReferences = {
    appointment: {
        required: true,
        uid: 'appointment',
        description: 'Appointment entry template. It is replicated once for every appointment of the self-service customer.',
    },
    appointmentConfirmed: {
        required: false,
        uid: 'appointment-confirmed',
        description: 'Optional appointment entry template that replaces an appointment after its attendance is confirmed. It supports the same data-get placeholders as data-ref="appointment".',
    },
    appointmentCanceled: {
        required: false,
        uid: 'appointment-canceled',
        description: 'Optional appointment entry template that replaces an appointment after its attendance is cancelled. It supports the same data-get placeholders as data-ref="appointment".',
    },
    appointmentStartTime: {
        dataTag: 'get',
        required: false,
        uid: 'appointment-start-time',
        dontRemoveFromDom: true,
        keepRefTag: true,
        description: 'Displays the appointment start time.',
    },
    appointmentEndTime: {
        dataTag: 'get',
        required: false,
        uid: 'appointment-end-time',
        dontRemoveFromDom: true,
        keepRefTag: true,
        description: 'Displays the appointment end time.',
    },
    appointmentDuration: {
        dataTag: 'get',
        required: false,
        uid: 'appointment-duration',
        dontRemoveFromDom: true,
        keepRefTag: true,
        description: 'Displays the appointment duration calculated from its start and end time.',
    },
    appointmentTitle: {
        dataTag: 'get',
        required: false,
        uid: 'appointment-title',
        dontRemoveFromDom: true,
        keepRefTag: true,
        description: 'Displays the appointment title.',
    },
    confirmAttendance: {
        dataTag: 'action',
        required: false,
        uid: 'confirm-attendance',
        dontRemoveFromDom: true,
        keepRefTag: true,
        description: 'Confirms the customer attendance for the appointment entry it belongs to.',
    },
    cancelAttendance: {
        dataTag: 'action',
        required: false,
        uid: 'cancel-attendance',
        dontRemoveFromDom: true,
        keepRefTag: true,
        description: 'Cancels the customer attendance for the appointment entry it belongs to.',
    },
};
